import LMSDispatcher from "../LMSDispatcher";

import * as CONSTANTS from "../../utilities/Constants";

import { ISubmitHeaderData } from "../../models/shared/SubmitHeaderData";

class SubmitHeaderActions {

    async update(data: ISubmitHeaderData) {
        LMSDispatcher.dispatch({
            type: CONSTANTS.SUBMIT_DISABLED,
            payload: data
        });
    }
}

const submitHeaderActions = new SubmitHeaderActions();
export default submitHeaderActions;